import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function formatCurrency(value) {
  if (!value && value !== 0) return 'GHS 0';
  const num = Number(String(value).replace(/[^\d.]/g, ''));
  if (isNaN(num)) return `GHS ${value}`;
  return `GHS ${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function UnpaidPremiums() {
  const location = useLocation();
  const navigate = useNavigate();
  const locationState = location.state || {};

  const [selectedMonths, setSelectedMonths] = useState([]);
  const [paymentType, setPaymentType] = useState('full');
  const [partialAmount, setPartialAmount] = useState('');
  const [savedPartialAmount, setSavedPartialAmount] = useState(null);
  const [isPartialSaved, setIsPartialSaved] = useState(false);

  const unpaidPremiums = [
    { id: 1, month: 'May', reason: 'Insufficient funds', amount: 80 },
    { id: 2, month: 'June', reason: 'Bank verification pending', amount: 80 },
    { id: 3, month: 'July', reason: 'Payment failed', amount: 80 },
    { id: 4, month: 'August', reason: 'Card declined', amount: 80 },
  ];

  const handleCheckboxChange = (id) => {
    setSelectedMonths(prev => 
      prev.includes(id) 
        ? prev.filter(monthId => monthId !== id)
        : [...prev, id]
    );
  };

  const totalSelected = selectedMonths.reduce((sum, id) => {
    const premium = unpaidPremiums.find(p => p.id === id);
    return sum + (premium ? premium.amount : 0);
  }, 0);

  return (
    <div style={{ minHeight: '80vh', background: '#f5f6fa', padding: 24, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 32 }}>
      <div style={{ width: '100%', maxWidth: 700 }}>
        <div style={{ 
          background: '#fff', 
          borderRadius: 18, 
          boxShadow: '0 4px 24px 0 rgba(0,0,0,0.10)', 
          padding: '32px 48px', 
          width: '100%'
        }}>
          {/* Header Section */}
          <div style={{ marginBottom: 32 }}>
            <h1 style={{ 
              fontSize: '24px', 
              fontWeight: '800', 
              color: '#000', 
              marginBottom: '12px' 
            }}>
              Pay Unpaid Premiums
            </h1>
            <p style={{ 
              fontSize: '16px', 
              color: '#666'
            }}>
              Select the months you'd like to make a payment arrangement for
            </p>
          </div>
          <div style={{ marginTop: 32, borderTop: '1px solid #eee', paddingTop: 24 }}></div>  

          {/* Unpaid Premiums List */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {unpaidPremiums.map((premium) => (
              <div key={premium.id} style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '16px 20px',
                background: '#f8f9fa',
                borderRadius: 12,
                border: '1px solid #eee',
                borderBottom: '1px solid #eee',
                position: 'relative',
                marginBottom: '8px'
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>{premium.month}</div>
                  <div style={{ fontSize: '14px', color: '#666', display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <span>Reason - {premium.reason}</span>
                    <span style={{ fontWeight: '600' }}>Amount - {formatCurrency(premium.amount)}</span>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
                  <input
                    type="checkbox"
                    checked={selectedMonths.includes(premium.id)}
                    onChange={() => handleCheckboxChange(premium.id)}
                    style={{ 
                      width: 20, 
                      height: 20,
                      cursor: 'pointer',
                      accentColor: '#00a651',
                      border: '2px solid #00a651',
                      borderRadius: '4px'
                    }}
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Payment Options */}
          <div style={{ 
            marginTop: 32,
            borderTop: '1px solid #eee',
            paddingTop: 24,
            display: 'flex',
            flexDirection: 'column',
            gap: 16
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <label style={{ 
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                cursor: 'pointer'
              }}>
                <input
                  type="radio"
                  name="paymentType"
                  value="full"
                  checked={paymentType === 'full'}
                  onChange={(e) => setPaymentType(e.target.value)}
                  style={{
                    width: 18,
                    height: 18,
                    cursor: 'pointer',
                    accentColor: '#00a651'
                  }}
                />
                <span style={{ fontSize: '16px' }}>Pay Full Amount</span>
              </label>
              
              <label style={{ 
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                cursor: 'pointer',
                width: '100%',
                justifyContent: 'space-between'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <input
                    type="radio"
                    name="paymentType"
                    value="partial"
                    checked={paymentType === 'partial'}
                    onChange={(e) => setPaymentType(e.target.value)}
                    style={{
                      width: 18,
                      height: 18,
                      cursor: 'pointer',
                      accentColor: '#00a651'
                    }}
                  />
                  <span style={{ fontSize: '16px', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span>Partial Payment</span>
                    {isPartialSaved && (
                      <span style={{ fontWeight: 600 }}>({formatCurrency(savedPartialAmount)})</span>
                    )}
                  </span>
                </div>
                {isPartialSaved && (
                  <div>
                    <button
                      className="btn"
                      style={{ background: 'transparent', border: 'none', color: '#666', textDecoration: 'underline', cursor: 'pointer', padding: 0 }}
                      onClick={(e) => {
                        // prevent the label click from selecting the radio again
                        e.stopPropagation();
                        // clear saved partial
                        setIsPartialSaved(false);
                        setPartialAmount('');
                        setSavedPartialAmount(null);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </label>
            </div>

            {paymentType === 'partial' && (
              <div style={{ marginTop: 8 }}>
                {!isPartialSaved && (
                  // input with inline Save button positioned to the far right inside the field
                  <div style={{ position: 'relative' }}>
                    <input
                      type="text"
                      inputMode="decimal"
                      pattern="[0-9]*"
                      placeholder="Enter Amount"
                      value={partialAmount}
                      onChange={(e) => {
                        // allow only digits and a single dot for decimals
                        let val = e.target.value.replace(/[^0-9.]/g, '');
                        val = val.replace(/(\..*)\./g, '$1');
                        setPartialAmount(val);
                      }}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        paddingRight: 110, // space for the inline save button
                        fontSize: '16px',
                        border: '1px solid #ddd',
                        borderRadius: 8,
                        outline: 'none'
                      }}
                    />
                    <button
                      className={partialAmount ? 'btn btn-primary' : 'btn btn-white'}
                      style={{
                        position: 'absolute',
                        right: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        padding: '8px 12px',
                        fontWeight: 600,
                        borderRadius: 50,
                        height: 36,
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      onClick={() => {
                        // save entered partial amount and hide input
                        setSavedPartialAmount(partialAmount);
                        setIsPartialSaved(true);
                      }}
                      disabled={!partialAmount}
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Total and Action Button */}
          <div style={{ marginTop: 32, borderTop: '1px solid #eee', paddingTop: 24 }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center',
              gap: 8,
              marginBottom: 24
            }}>
              <span style={{ fontSize: '16px', color: '#666' }}>Total Payment</span>
              <span style={{ fontSize: '16px', color: '#666' }}>=</span>
              <span style={{ fontSize: '20px', fontWeight: '700' }}>{formatCurrency(totalSelected)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                className="btn btn-primary"
                style={{ 
                  width: 'auto', 
                  padding: '14px 28px', 
                  fontSize: '16px', 
                  fontWeight: '600',
                  opacity: selectedMonths.length === 0 ? 0.6 : 1,
                  cursor: selectedMonths.length === 0 ? 'not-allowed' : 'pointer'
                }}
                disabled={selectedMonths.length === 0}
                onClick={() => {
                  // Prepare payment data to pass to next page. Include full premium objects
                  const selectedPremiums = selectedMonths
                    .map(id => unpaidPremiums.find(p => p.id === id))
                    .filter(Boolean);

                  const paymentData = {
                    // include policy info if provided via route state
                    policyNumber: locationState?.policyNumber || null,
                    policyName: locationState?.policyName || null,
                    selectedMonths, // legacy ids (kept for backwards compatibility)
                    selectedPremiums,
                    paymentType,
                    partialAmount: isPartialSaved ? savedPartialAmount : null,
                    total: paymentType === 'partial' && isPartialSaved ? savedPartialAmount : totalSelected,
                  };

                  navigate('/dashboard/select-payment-method', { state: paymentData });
                }}
              >Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Export the component directly
export default UnpaidPremiums;